export default "__VITE_ASSET__DxxzvrFW__"